import DOMPurify from 'dompurify';

function mergeRelToken(relValue: string, token: string): string {
  const tokens = relValue
    .split(/\s+/)
    .map((x) => x.trim())
    .filter(Boolean);
  if (!tokens.includes(token)) tokens.push(token);
  return tokens.join(' ');
}

export function normalizeRichTextLinks(raw: string): string {
  const html = String(raw || '');
  if (!html) return '';
  if (!/<a[\s>]/i.test(html)) return html;
  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const anchors = doc.querySelectorAll('a[href]');
  anchors.forEach((a) => {
    a.setAttribute('target', '_blank');
    const currentRel = a.getAttribute('rel') || '';
    let nextRel = mergeRelToken(currentRel, 'noopener');
    nextRel = mergeRelToken(nextRel, 'noreferrer');
    a.setAttribute('rel', nextRel);
  });
  return doc.body.innerHTML;
}

export function sanitizeAndNormalizeRichText(raw: string): string {
  const sanitized = DOMPurify.sanitize(String(raw || ''));
  return normalizeRichTextLinks(sanitized);
}
